// filepath: /home/yosef-benny-widyokarsono/kominfo/emas/app/javascript/controllers/alert_controller.js
import { Controller } from "@hotwired/stimulus"
import { Alert } from "bootstrap"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 5000 }
  }

  connect() {
    console.log("Alert controller connected!", this.element); // Log connection
    console.log("Delay value:", this.delayValue); // Log the delay value being used
    this.timeout = setTimeout(() => {
      console.log("Timeout finished, attempting to close alert."); // Log before closing
      this.close()
    }, this.delayValue)
  }

  disconnect() {
    console.log("Alert controller disconnected.", this.element); // Log disconnection
    clearTimeout(this.timeout)
  }

  close() {
    console.log("Close method called."); // Log when close is called
    const alertInstance = Alert.getOrCreateInstance(this.element)
    if (alertInstance) {
      console.log("Bootstrap Alert instance found, calling close().");
      alertInstance.close()
    } else {
      console.warn("Bootstrap Alert instance NOT found, removing element directly."); // Warn if Bootstrap JS fails
      this.element.remove()
    }
  }
}